import React from 'react';
import { css, Theme, useTheme } from "@emotion/react";
import RoundButton from "core/Components/Buttons/RoundButton";
import { NOOP } from "core/constants";

type Props = {
    label: string,
    onClick: (e: React.MouseEvent) => void,
    loading?: boolean,
}

const PaymentButton = (
    {
        label = 'Place order',
        onClick = NOOP,
        loading = false,
    }: Props
) => {
    const theme: Theme = useTheme();
    const style = css`
        position: relative;
        display: flex;
        justify-content: center;
        margin-top: 52px;
    `;

    return (
        <div css={style}>
            <RoundButton
                buttonWidth={232}
                buttonHeight={51}
                textFontSize={21}
                textColour={theme.colours.shipGray}
                textHoverColour={theme.colours.malibu4}
                backgroundColour={'white'}
                useTextHover={false}
                onButtonClick={onClick}
                forceLoading={loading}
            >
                <span>{label}</span>
            </RoundButton>
        </div>
    )
};

export default PaymentButton;